import React from 'react';
import './ChatWindow.css';

const ChatWindow = ({ 
    messages, 
    selectedModel,
    modelConfig
}) => {
    const handleCopy = (content) => {
        navigator.clipboard.writeText(content).then(() => {
            // 可以添加复制成功的提示
        });
    };

    // 检测内容是否包含代码块
    const hasCodeBlock = (content) => {
        return content.includes('```');
    };

    // 格式化代码块
    const formatContent = (content) => {
        if (!hasCodeBlock(content)) {
            return <p>{content}</p>;
        }

        const parts = content.split(/(```[\s\S]*?```)/g);
        return parts.map((part, index) => {
            if (part.startsWith('```') && part.endsWith('```')) {
                // 提取语言和代码
                const code = part.slice(3, -3);
                const firstLineBreak = code.indexOf('\n');
                const language = firstLineBreak > 0 ? code.slice(0, firstLineBreak).trim() : '';
                const actualCode = firstLineBreak > 0 ? code.slice(firstLineBreak + 1) : code;

                return (
                    <div key={index} className="code-block">
                        {language && <div className="code-language">{language}</div>}
                        <pre>
                            <code>{actualCode}</code>
                        </pre>
                    </div>
                );
            }
            return <p key={index}>{part}</p>;
        });
    };

    return (
        <div className="chat-window">
            <div className="chat-messages">
                {messages.map((message, index) => (
                    <div 
                        key={index} 
                        className={`message ${message.role}`}
                    >
                        <div className="message-avatar">
                            {message.role === 'user' ? (
                                <span className="user-avatar">👤</span>
                            ) : (
                                <img 
                                    src={modelConfig?.icon} 
                                    alt={modelConfig?.label} 
                                    className="model-avatar"
                                />
                            )}
                        </div>
                        <div className="message-content">
                            <div className="message-header">
                                <span className="message-sender">
                                    {message.role === 'user' ? '你' : modelConfig?.label}
                                </span>
                                <span className="message-time">
                                    {new Date(message.timestamp).toLocaleTimeString()}
                                </span>
                                <button 
                                    className="copy-button"
                                    onClick={() => handleCopy(message.content)}
                                    title="复制内容"
                                >
                                    📋
                                </button>
                            </div>
                            <div className="message-body">
                                {formatContent(message.content)}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ChatWindow; 